import Format from "../components/format/Format";
import { ButtonValues } from "../types/button.type";

export default function Json() {
    const buttons: ButtonValues[] = [
        {
            api: '/api/json/pretty-print',
            buttonLabel: 'Format',
            outputLabel: 'JSON',
        },
        {
            api: '/api/json/is-valid',
            buttonLabel: 'Validate',
            outputLabel: 'Valid',
        },
        {
            api: '/api/json/yaml',
            buttonLabel: 'To YAML',
            outputLabel: 'YAML',
        },
        {
            api: '/api/json/toml',
            buttonLabel: 'To TOML',
            outputLabel: 'TOML',
        },
        {
            api: '/api/json/xml',
            buttonLabel: 'To XML',
            outputLabel: 'XML',
        },
        {
            api: '/api/json/csv',
            buttonLabel: 'To CSV',
            outputLabel: 'CSV',
        },
    ];

    return (
        <Format inputLabel='JSON' buttons={buttons} />
    );
}